import { graphql, useStaticQuery } from 'gatsby'

const useSiteMetadataQuery = () => {
  const data = useStaticQuery(
    graphql`
      query {
        site {
          siteMetadata {
            siteUrl
            title
            social {
              facebook
              instagram
              twitter
            }
          }
        }
        metadata: contentfulSiteMetadata(slug: { eq: "site-metadata" }) {
          default: defaultPageMetadata {
            description {
              description
            }
            image {
              gatsbyImageData(
                height: 630
                quality: 90
                layout: FIXED
                width: 1200
              )
            }
            path
            title
          }
          pages: pageMetadata {
            description {
              description
            }
            image {
              gatsbyImageData(
                height: 630
                quality: 90
                layout: FIXED
                width: 1200
              )
            }
            path
            structuredData {
              internal {
                content
              }
            }
            title
          }
        }
      }
    `
  )

  return data
}

export default useSiteMetadataQuery
